import React from 'react'
import { Link } from 'react-router-dom'
import Navbar from '../components/navbar'
import hero from '../assets/images/hero/h2.jpg'
import icon1 from '../assets/images/branding/icon2.png'
import Footer from '../components/footer'
import ScrollToTop from '../components/scroll-to-top'
import Instalacionesresults from '../components/instalacionesresults'

export default function Resultadosservicios() {
    return (
        <>
            <Navbar />

            <section className="bg-half-170 d-table w-100" style={{ backgroundImage: `url(${hero})`, backgroundPosition: 'center' }}>
                <div className="bg-overlay bg-gradient-overlay"></div>
                <div className="container">
                    <div className="row mt-5 justify-content-center">
                        <div className="col-12">
                            <div className="title-heading text-center">
                                <h5 className="heading fw-semibold mb-0 sub-heading text-white title-dark">Buscar</h5>
                            </div>
                        </div>
                    </div>

                    <div className="position-middle-bottom">
                        <nav aria-label="breadcrumb" className="d-block">
                            <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </section>
            <div className="position-relative">
                <div className="shape overflow-hidden text-white">
                    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                    </svg>
                </div>
            </div>

            <section className="section">
                <div className="container mb-5">
                    <div className="row justify-content-center">
                        <div className="col-sm-3 col-4 text-center">
                            <img src={icon1} className="img-fluid w-50 mx-auto" alt="" />
                        </div>
                    </div>
                </div>
                <div className="container mt-50 mt-60">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="section-title text-center mb-4 pb-2">
                                <h4 className="title mb-3">Resultados de su búsqueda</h4>
                            </div>
                        </div>
                    </div>
                    <Instalacionesresults />
                </div>
            </section>

            <Footer />

            <ScrollToTop />
        </>
    )
}
